import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterializeModule } from 'angular2-materialize';
import { NgxMdModule as MarkdownModule } from 'ngx-md';

import { SharedModule } from '../shared/shared.module';

import { UnitRoutingModule } from './unit-routing.module';
import { UnitService } from './unit.service';
import { UnitListComponent } from './unit-list/unit-list.component';
import { UnitComponent } from './unit.component';
import { EducationDescriptionComponent } from './education-decription.component';

@NgModule({
  imports: [
    CommonModule,
    MaterializeModule,
    MarkdownModule.forRoot(),
    SharedModule,
    UnitRoutingModule
  ],
  declarations: [
    UnitComponent,
    UnitListComponent,
    EducationDescriptionComponent
  ],
  providers: [UnitService],
  exports: [
    UnitListComponent,
    EducationDescriptionComponent
  ]
})
export class UnitModule { }
